import { AxiosResponse } from 'axios';
import apiInterceptor from '../utils/axios';
import { Area } from '../types/Area/Area';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APIAREA = 'api/Catalog/Area/';

export default class AreaService {

    static async GetAreas(): Promise<Array<Area>> {
        const response1: AxiosResponse<Array<Area>> = await apiInterceptor.get(`${SERV_BACK}${APIAREA}`,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }
    // Mejorar para traer directamente Areas
    static async GetAreasGestorbyUsername(usuario: string): Promise<Array<number>> {
        const response1: AxiosResponse<Array<number>> = await apiInterceptor.get(`${SERV_BACK}${APIAREA}areasgestorbyusername/${usuario}`,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }

}